import { render, staticRenderFns } from "./baniere.vue?vue&type=template&id=f8094a50&"
import script from "./baniere.vue?vue&type=script&lang=js&"
export * from "./baniere.vue?vue&type=script&lang=js&"
import style0 from "./baniere.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports